import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "contact-section",
  id: "contact"
}
const _hoisted_2 = { class: "contact-container" }
const _hoisted_3 = { class: "contact-info" }
const _hoisted_4 = { class: "info-card" }
const _hoisted_5 = { class: "info-icon" }
const _hoisted_6 = { class: "info-card" }
const _hoisted_7 = { class: "info-icon" }
const _hoisted_8 = { class: "info-card" }
const _hoisted_9 = { class: "info-icon" }
const _hoisted_10 = { class: "contact-form-wrapper" }
const _hoisted_11 = { class: "contact-form" }
const _hoisted_12 = {
  type: "submit",
  class: "submit-btn"
}

import {Mail, MapPin, Phone, Send} from "lucide-vue-next";

import "@/assets/styles/contact.css";

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "contact-header" }, [
      _createElementVNode("span", { class: "section-badge" }, " Kontakt "),
      _createElementVNode("h2", null, " Lassen Sie uns Ihr Projekt starten "),
      _createElementVNode("p", null, " Sie planen eine neue Außenanlage, benötigen Unterstützung bei der Gartenpflege oder möchten sich beraten lassen? ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Phone))
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", null, [
            _createElementVNode("h3", null, "Telefon"),
            _createElementVNode("p", null, "+49 123 456789")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(Mail))
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", null, [
            _createElementVNode("h3", null, "E-Mail"),
            _createElementVNode("p", null, "info@testgarten.de")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(MapPin))
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", null, [
            _createElementVNode("h3", null, "Standort"),
            _createElementVNode("p", null, "Wiesbaden & Umgebung")
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("form", _hoisted_11, [
          _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"form-grid\"><div class=\"form-group\"><label>Name</label><input type=\"text\" placeholder=\"Ihr Name\"></div><div class=\"form-group\"><label>E-Mail</label><input type=\"email\" placeholder=\"ihre@email.de\"></div></div><div class=\"form-group\"><label>Telefon</label><input type=\"text\" placeholder=\"+49 ...\"></div><div class=\"form-group\"><label>Nachricht</label><textarea rows=\"6\" placeholder=\"Beschreiben Sie Ihr Projekt...\"></textarea></div>", 3)),
          _createElementVNode("button", _hoisted_12, [
            _createVNode(_unref(Send)),
            _cache[3] || (_cache[3] = _createTextVNode(" Anfrage senden ", -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})